import BaseListPresenter from "../../../../base/BaseListPresenter";

class UserAccomplishmentPresenter extends BaseListPresenter {
  init() {
    const user = this.view.getCurrentUser();
    this.limit = 10;
    this.where = {
      username: user.username,
    };
    this.search = {};
    this.filter = {};
    this.include = ["employee"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }
  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }
}

export default UserAccomplishmentPresenter;
